import { UserContext } from "@/context/User/UserContext";
import { getPlatforms } from "@/services/Platform.service";
import { Platform } from "@/types/platform.types";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import CreatePlatform from "../dialog/CreatePlatform";
import ColumnHeader from "../table/ColumnHeader";
import LawFirmTable from "../table/LawFirmTable";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Platforms = () => {
	const user = useContext(UserContext);

	const platforms = useQuery({
		queryKey: ["platforms"],
		queryFn: () => getPlatforms(user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<div>
					<h1 className="text-3xl font-bold">Platforms</h1>
				</div>
				<CreatePlatform user={user} />
			</div>
			<div className="bg-white pb-4 border rounded-md shadow-sm">
				{platforms.isLoading ? (
					<div className="grid gap-4 pt-4">
						{Array.from({ length: 10 }).map((_, num) => (
							<Skeleton key={num} className="h-12 w-full" />
						))}
					</div>
				) : platforms.data ? (
					<LawFirmTable data={platforms.data} columns={Columns} />
				) : (
					<p>No data</p>
				)}
			</div>
		</div>
	);
};

export default Platforms;

const Columns: ColumnDef<Platform>[] = [
	{
		accessorKey: "platformid",
		header: ({ column }) => <ColumnHeader column={column} title="Platform Id" />,
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/platform/${row.original.platformid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						{row.getValue("platformid")}
					</Button>
				</NavLink>
			</div>
		),
	},
	{
		accessorKey: "platformname",
		header: ({ column }) => <ColumnHeader column={column} title="Platform" />,
	},
	{
		accessorKey: "actions",
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/platform/${row.original.platformid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						View
					</Button>
				</NavLink>
			</div>
		),
	},
];
